// extracted by mini-css-extract-plugin
export default {"btn":"ProductThumb_btn__8oRsr"};